import Api from '@/services/Api'

export default {
  index(query) {
    return Api().get('item', {
      params: query
    })
  },
  indexlist(query) {
    return Api().get('item/list', {
      params: query
    })
  },
  choose(query) {
    return Api().get('item/choose', {
      params: query
    })
  },
  updateprices(items) {
    return Api().post('item/updateprices', items)
  },
  
  show(itemId) {
    return Api().get(`item/${itemId}`)
  },
  post(newitem) {
    return Api().post('item', newitem)
  },
  put(item) {
    return Api().put(`item/${item.id}`, item)
  },
  delete(itemId) {
    return Api().delete(`item/${itemId}`)
  },
  updatekpd(query) {
    return Api().get('item/updatekpd', {
      params: query
    })
  },
  // Slika artikla: upload u folder firme i dohvat natrag. Dohvat ide preko
  // Api()-ja, dakle s tokenom prijavljenog korisnika, pa slika nije javna.
  uploadPicture(formData) {
    return Api().post('item/picture', formData)
  },
  picture(query) {
    return Api().get('item/picture/show', {
      params: query
    })
  },
  // Slika s tudje stranice: preglednik je ne smije procitati sam (CORS), pa je
  // dohvaca posluzitelj i vraca kao data URI.
  fetchPicture(query) {
    return Api().get('item/picture/fetch', {
      params: query
    })
  },
  // Artikli po sifri dobavljaca - za povezivanje kod uvoza iz Excela i primke
  // iz eRacuna. Vraca mapu, da se ne ide na bazu za svaku stavku posebno.
  bysuppcode(query) {
    return Api().get('item/bysuppcode', {
      params: query
    })
  },
  // Sidrene (dodatne) cijene - NN 101/2026. Popis ide cijeli, bez stranicenja,
  // jer se cjenik objavljuje u komadu.
  sidrene(query) {
    return Api().get('item/sidrene', {
      params: query
    })
  },
  sidreneNapuni(body) {
    return Api().post('item/sidrene/napuni', body)
  }
}